export const defaultData = {
  isNormalized: false,
  isPriceVisible: true,
  isBaseVisible: true,
  visibleTasks: null,
  maxDepth: 5,
  enableCaption: true,
  caption: null
}

export { default as EditDataForm } from "./EditDataForm"
export { default as FragComponent } from "./FragComponent"
export { default as pageSplitter } from "./pageSplitter"
